export const getThreshold = (
  days: number,
  thresholds: IThreshold[],
): IThreshold | undefined => {
  const threshold = thresholds.filter(t => days >= t.min && days <= t.max)
  return threshold[0]
}
